import {
  SchoolOwlState,
  SchoolPreferenceEnum,
  SchoolStateEnum
} from '@model/school/school-configuation.model'

export const mockSchoolOwlState: SchoolOwlState = {
  schoolId: 1,
  schoolLogicalId: '1',
  schoolName: 'Mock School',
  drillMode: false,
  drillModeChanged: null,
  preference: SchoolPreferenceEnum.manual,
  state: SchoolStateEnum.routine,
  lastSuspectedEvent: null,
  historicDateExtensionOverride: null,
  additionalData: null
}
